import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { WidgetProps } from "../widgets";
import bg from "../../assets/backgrounds/brave-firefighter-with-axe-standing-front-frightening-explosion-digital-art-style-illustration-painting.png";
import { BWMembershipStatus, IMembershipDetails } from "../../models/bwMembership";
import { IState } from "../../redux/reducers";
import { LOCAL_STORAGE_KEYS } from "../../models/localStorage";
import "./DigitalAccess.scss";

type DigitalAccessProps = {
	ignoreSubscriptionStatus: boolean;
} & WidgetProps;

export const DigitalAccess: React.FC<DigitalAccessProps> = (props: DigitalAccessProps) => {
	const { ignoreSubscriptionStatus } = props;
	const membershipDetails: IMembershipDetails = useSelector(
		(state: IState) => state.subscriptionStore.membershipDetails
	);

	useEffect(() => {
		// console.log("dana membershipDetails:", membershipDetails);
	}, [membershipDetails]);

	if (props.page?.id === "streams" && props.idPage) return null;
	const validSubscription: boolean = membershipDetails?.status === BWMembershipStatus.ACTIVE;
	if (!ignoreSubscriptionStatus && validSubscription) return null;
	// console.log("dana membershipDetails:", membershipDetails);

	return (
		<div className={clsx("digital-access-container position-relative")}>
			<img src={bg} width={"100%"} className="position-absolute" />
			<div className="container section-padding da-content-container">
				<h1 className="text-center">Receive Unlimited Digital Access</h1>
				<p className="text-center mt-3">
					Join in on receiving the latest news about firefighters, events, and more when you subscribe to
					Straight Streams today.
				</p>

				<div className="d-flex flex-column flex-md-row streams-card-container align-items-center align-items-md-stretch justify-content-center">
					<div className="card bg-light flex-grow-1">
						<div className="card-body d-flex flex-column align-items-center">
							<h3>Magazine Access</h3>
							<span className="text-md mt-2">Non-Members</span>
							<NavLink to="/join">
								<button className="btn btn-info">Subscriber Access</button>
							</NavLink>
							<span className="text-md">LACFBW Member Access (Free Access)</span>
							<NavLink
								to="/login"
								onClick={() => localStorage.setItem(LOCAL_STORAGE_KEYS.LOGIN_REDIRECT, "/payment")}
							>
								<button className="btn btn-primary">Member Access</button>
							</NavLink>
						</div>
					</div>
					<div className="card bg-light">
						<div className="card-body d-flex flex-column align-items-center">
							<h3>Subscription Pricing</h3>
							<span className="text-md mt-1">
								Not a LACFBW member? You are welcome to subscribe to the Straight Streams magazine.{" "}
							</span>
							<span className="text-md mt-5">Non-Member: $75</span>
							<span className="text-md mt-2">Member: Free</span>
							<NavLink to="/join">
								<button className="btn btn-link">Subscribe</button>
							</NavLink>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
